import _export from '../internals/export.js';
import objectSetPrototypeOf from '../internals/object-set-prototype-of.js';

var $ = _export;
var setPrototypeOf = objectSetPrototypeOf; // `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof

$({
  target: 'Object',
  stat: true
}, {
  setPrototypeOf: setPrototypeOf
});
